
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, CheckCircle, AlertTriangle } from "lucide-react";

interface ValidationStatusProps {
  websiteCheckResult: any;
}

export function ValidationStatus({ websiteCheckResult }: ValidationStatusProps) {
  if (!websiteCheckResult) return null;
  
  return (
    <Alert 
      variant={websiteCheckResult.pixelFound ? "default" : "destructive"}
      className={websiteCheckResult.pixelFound ? "bg-green-50 border-green-200" : ""}
    >
      {websiteCheckResult.pixelFound ? (
        <>
          <CheckCircle className="h-4 w-4 text-green-500" />
          <AlertDescription className="text-green-700">
            Pixel found on website! Installation is correct.
          </AlertDescription>
        </>
      ) : websiteCheckResult.anyPixelFound ? (
        <>
          <AlertTriangle className="h-4 w-4 text-amber-500" />
          <AlertDescription className="text-amber-700">
            A pixel was found on your website, but with a different ID than expected.
          </AlertDescription>
        </>
      ) : (
        <>
          <AlertTriangle className="h-4 w-4 text-red-500" />
          <AlertDescription className="text-red-700">
            Pixel not found on your website. Please check your installation.
          </AlertDescription>
        </>
      )}
    </Alert>
  );
}
